import { PRODUCT_ANALYSIS_RUN_STAGES, type ProductAnalysisRunProgress } from '@ozon-ai/analysis/contracts';
import { Spinner } from '@/components/ui/spinner.tsx';
import { Check } from 'lucide-react';

export function ProductAnalysisRunProgressView({ progress }: { progress: ProductAnalysisRunProgress }) {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm font-semibold">Выполнение анализа</p>
      {PRODUCT_ANALYSIS_RUN_STAGES.map((stage) => {
        const completed = progress.completedStages.includes(stage.id);
        const inProgress = progress.currentStages.includes(stage.id);

        return (
          <div key={stage.id} className="flex min-h-6 items-center gap-3">
            <div className="flex w-5 items-center justify-center">
              {completed ? (
                <Check size={16} strokeWidth={2.5} className="text-primary" aria-hidden />
              ) : inProgress ? (
                <Spinner className="size-4" />
              ) : null}
            </div>
            <p
              className={
                inProgress
                  ? 'text-sm font-semibold text-foreground'
                  : completed
                    ? 'text-sm text-foreground'
                    : 'text-sm text-muted-foreground'
              }
            >
              {stage.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}
